import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	minimize: {
		id: 'minimizable-modal.modal-container.ai-enabled-header.minimize',
		defaultMessage: 'Minimize',
		description: 'Tooltip for minimizing a modal',
	},
	minimizeDisabled: {
		id: 'minimizable-modal.modal-container.ai-enabled-header.minimize-disabled',
		defaultMessage: "Can't minimize this view",
		description: 'Tooltip for minimizing a modal',
	},
});
